/* ==========================================================================
   Soybarber — sb-motion.js
   Port de motion-primitives a Liquid, sobre la Web Animations API nativa.

   Por que no el bundle de Motion por CDN:
   en motion@12.43.0/dist/motion.js el `animate()` global NO funciona sobre
   elementos del DOM (crea 0 animaciones y su .finished nunca resuelve); solo
   `animateMini` responde. Comprobado en soybarber.com el 7-sep-2026. Ademas el
   sitio ya carga 2.44 MB y 121 scripts, y el rendimiento es de las peores notas
   de la auditoria. Asi que se reproducen las mismas primitivas y los mismos
   resortes con WAAPI: cero dependencias, cero CDN, ~6 KB.

   Los resortes se convierten a easing linear() muestreando la ecuacion del
   oscilador amortiguado — la misma tecnica que usa Motion por dentro — para
   que "stiffness / damping / mass" signifiquen exactamente lo mismo.
   El del DisclosureCard (26.7 / 4.1 / 0.2) da 467 ms subamortiguado, con rebote.

   Primitivas (se activan con atributos data-*):
     data-reveal="fade-up|fade|blur-scale|fade-in-blur"  entrada al hacer scroll
     data-reveal-group + data-reveal-stagger="0.06"      escalona a los hijos
     data-text-effect="word" [data-text-immediate]       hero palabra por palabra
     data-infinite-slider="55" [data-slider-hover]       marquee continuo
       [data-slider-reverse]  +  hijo con data-slider-track
     data-disclosure                                     tarjeta desplegable
       data-disclosure-media / -trigger / -content
     data-magnetic="0.22"                                boton que sigue al cursor
     data-counter="8"                                    numero que cuenta

   Reglas (skills framer-motion + ui-ux-pro-max):
     - solo transform / opacity / filter, salvo la altura del disclosure, que es
       su razon de ser: se mide scrollHeight, se anima a px y al terminar vuelve
       a 'auto' para seguir siendo responsivo.
     - una sola animacion viva por elemento; will-change se pone al empezar y se
       quita al terminar.
     - prefers-reduced-motion: estado final, sin animar.
     - 1-2 elementos animados por vista; el marquee se detiene fuera de pantalla
       y con la pestana en segundo plano.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var html = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (reduce || !doc.body || typeof Element.prototype.animate !== 'function') {
    html.classList.add('sb-motion-off');
    return;
  }
  html.classList.add('sb-motion');

  var EASE_OUT = 'cubic-bezier(.22, 1, .36, 1)';

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel));
  }

  /* ---------------------------------------------------------------------
   * Resorte -> easing linear() + duracion.
   * Oscilador amortiguado con las mismas unidades que Motion/Framer.
   * ------------------------------------------------------------------ */
  var supportsLinear = (function () {
    try { return CSS.supports('animation-timing-function', 'linear(0, 1)'); }
    catch (e) { return false; }
  })();

  var springCache = {};
  function spring(stiffness, damping, mass) {
    var key = stiffness + '/' + damping + '/' + mass;
    if (springCache[key]) return springCache[key];

    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));

    var at;
    if (zeta < 1) {
      var wd = w0 * Math.sqrt(1 - zeta * zeta);
      at = function (t) {
        return 1 - Math.exp(-zeta * w0 * t) *
          (Math.cos(wd * t) + (zeta * w0 / wd) * Math.sin(wd * t));
      };
    } else {
      at = function (t) { return 1 - (1 + w0 * t) * Math.exp(-w0 * t); };
    }

    var dt = 1 / 120, t = 0, duration = 2;
    for (var i = 1; i <= 720; i++) {
      t = i * dt;
      if (Math.abs(1 - at(t)) < 0.004 && Math.abs(at(t) - at(t - dt)) < 0.004) {
        duration = t;
        break;
      }
    }

    var easing;
    if (supportsLinear) {
      var pts = [], n = 60;
      for (var j = 0; j <= n; j++) pts.push(at((j / n) * duration).toFixed(4));
      easing = 'linear(' + pts.join(',') + ')';
    } else {
      easing = EASE_OUT; /* navegador viejo: se pierde el rebote, no la funcion */
    }

    springCache[key] = { duration: Math.round(duration * 1000), easing: easing };
    return springCache[key];
  }

  /* El resorte exacto del DisclosureCard de motion-primitives. */
  var SPRING_DISCLOSURE = spring(26.7, 4.1, 0.2);
  var SPRING_PRESS = spring(320, 20, 0.3);

  /* Envoltura sobre element.animate con limpieza de will-change.
     No dependemos de .finished para la logica de estado: en pestanas en
     segundo plano puede no resolver nunca. Usamos onfinish + guarda por tiempo. */
  function anim(el, from, to, opts) {
    opts = opts || {};
    /* Una animacion por elemento: con fill:'both' se apilarian y cada toggle
       dejaria otra viva, gastando memoria y compositor. Se cancela la anterior
       marcandola para que su oncancel no dispare el onDone de aquella. */
    if (el.__sbAnim) {
      el.__sbAnim.__sbReplaced = true;
      try { el.__sbAnim.cancel(); } catch (e) {}
      el.__sbAnim = null;
    }
    el.style.willChange = opts.willChange || 'transform, opacity, filter';
    var a;
    try {
      a = el.animate([from, to], {
        duration: opts.duration != null ? opts.duration : 470,
        delay: opts.delay || 0,
        easing: opts.easing || EASE_OUT,
        fill: 'both'
      });
    } catch (e) {
      Object.keys(to).forEach(function (k) { el.style[k] = to[k]; });
      el.style.willChange = '';
      if (opts.onDone) opts.onDone();
      return null;
    }
    el.__sbAnim = a;
    var done = false;
    function finish() {
      if (done || a.__sbReplaced) return;
      done = true;
      if (el.__sbAnim === a) el.__sbAnim = null;
      el.style.willChange = '';
      if (opts.onDone) opts.onDone();
    }
    a.onfinish = finish;
    a.oncancel = finish;
    setTimeout(finish, (opts.duration || 470) + (opts.delay || 0) + 300);
    return a;
  }

  function onceInView(el, cb, amount, margin) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); cb(); }
      });
    }, { threshold: amount == null ? 0.12 : amount, rootMargin: margin || '0px 0px -8% 0px' });
    io.observe(el);
  }

  /* ---------------------------------------------------------------------
   * 1. Reveal (port de in-view.tsx)
   * ------------------------------------------------------------------ */
  var VARIANTS = {
    'fade-up':      { from: { opacity: 0, transform: 'translateY(24px)' },               to: { opacity: 1, transform: 'translateY(0px)' } },
    'fade':         { from: { opacity: 0 },                                              to: { opacity: 1 } },
    'blur-scale':   { from: { opacity: 0, transform: 'scale(.9)', filter: 'blur(8px)' }, to: { opacity: 1, transform: 'scale(1)', filter: 'blur(0px)' } },
    'fade-in-blur': { from: { opacity: 0, transform: 'translateY(18px)', filter: 'blur(10px)' }, to: { opacity: 1, transform: 'translateY(0px)', filter: 'blur(0px)' } }
  };
  function variantOf(n) { return VARIANTS[n] || VARIANTS['fade-up']; }

  function initReveal() {
    $$('[data-reveal]:not([data-reveal-ready])').forEach(function (el) {
      el.setAttribute('data-reveal-ready', '');
      var v = variantOf(el.getAttribute('data-reveal'));
      var delay = parseFloat(el.getAttribute('data-reveal-delay') || '0') * 1000;
      onceInView(el, function () {
        anim(el, v.from, v.to, { delay: delay, onDone: function () { el.style.opacity = '1'; } });
      });
    });

    $$('[data-reveal-group]:not([data-reveal-ready])').forEach(function (group) {
      group.setAttribute('data-reveal-ready', '');
      var v = variantOf(group.getAttribute('data-reveal-group'));
      var stagger = parseFloat(group.getAttribute('data-reveal-stagger') || '0.06') * 1000;
      var items = Array.prototype.slice.call(group.children);
      onceInView(group, function () {
        items.forEach(function (el, i) {
          anim(el, v.from, v.to, { delay: i * stagger, onDone: function () { el.style.opacity = '1'; } });
        });
      }, 0.08);
    });
  }

  /* ---------------------------------------------------------------------
   * 2. TextEffect — el H1 del hero (port de text-effect.tsx)
   * ------------------------------------------------------------------ */
  function splitWords(root) {
    var pieces = [];
    Array.prototype.slice.call(root.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = doc.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (chunk) {
          if (!chunk) return;
          if (/^\s+$/.test(chunk)) { frag.appendChild(doc.createTextNode(chunk)); return; }
          var s = doc.createElement('span');
          s.className = 'sb-word';
          s.textContent = chunk;
          frag.appendChild(s);
          pieces.push(s);
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        /* <em> y demas se animan enteros para no romper el subrayado rojo */
        node.classList.add('sb-word');
        pieces.push(node);
      }
    });
    return pieces;
  }

  function initTextEffects() {
    $$('[data-text-effect]:not([data-text-ready])').forEach(function (el) {
      el.setAttribute('data-text-ready', '');
      var words = splitWords(el);
      el.style.opacity = '1';
      if (!words.length) return;
      var stagger = parseFloat(el.getAttribute('data-text-stagger') || '0.055') * 1000;
      words.forEach(function (w) { w.style.opacity = '0'; });
      var run = function () {
        words.forEach(function (w, i) {
          anim(w,
            { opacity: 0, transform: 'translateY(.35em)', filter: 'blur(6px)' },
            { opacity: 1, transform: 'translateY(0em)', filter: 'blur(0px)' },
            { duration: 500, delay: i * stagger, onDone: function () { w.style.opacity = '1'; } });
        });
      };
      if (el.hasAttribute('data-text-immediate')) run();
      else onceInView(el, run, 0.2);
    });
  }

  /* ---------------------------------------------------------------------
   * 3. InfiniteSlider (port de infinite-slider.tsx)
   * ------------------------------------------------------------------ */
  function initInfiniteSliders() {
    $$('[data-infinite-slider]:not([data-slider-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-slider-ready', '');
      var track = wrap.querySelector('[data-slider-track]');
      if (!track || !track.children.length) return;

      var speed = parseFloat(wrap.getAttribute('data-infinite-slider') || '55');
      var hoverSpeed = parseFloat(wrap.getAttribute('data-slider-hover') || String(speed / 4));
      var reverse = wrap.hasAttribute('data-slider-reverse');

      /* Clon accesible: aria-hidden y sin foco, para no duplicar el contenido
         a los lectores de pantalla ni al tabulador. */
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-slider-track');
      $$('a,button', clone).forEach(function (n) { n.setAttribute('tabindex', '-1'); });
      track.parentNode.appendChild(clone);

      var current = speed, target = speed, offset = 0, raf = null, last = 0, visible = false;
      track.style.willChange = 'transform';
      clone.style.willChange = 'transform';

      function frame(t) {
        if (!last) last = t;
        var dt = Math.min((t - last) / 1000, 0.05);
        last = t;
        current += (target - current) * Math.min(dt * 6, 1);
        offset += current * dt;
        var w = track.scrollWidth;
        if (w > 0 && offset >= w) offset -= w;
        var x = reverse ? offset : -offset;
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
        clone.style.transform = 'translate3d(' + (reverse ? x - w : x + w) + 'px,0,0)';
        raf = requestAnimationFrame(frame);
      }
      function start() { if (!raf && visible && !doc.hidden) { last = 0; raf = requestAnimationFrame(frame); } }
      function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

      if (finePointer) {
        wrap.addEventListener('mouseenter', function () { target = hoverSpeed; });
        wrap.addEventListener('mouseleave', function () { target = speed; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          visible ? start() : stop();
        }, { threshold: 0 }).observe(wrap);
      } else { visible = true; start(); }
      doc.addEventListener('visibilitychange', function () { doc.hidden ? stop() : start(); });
    });
  }

  /* ---------------------------------------------------------------------
   * 4. Disclosure — port del DisclosureCard de motion-primitives.
   *    Imagen: scale 1 -> 1.1 y blur 0 -> 3px.
   *    Contenido: altura 0 -> auto y opacity 0 -> 1.
   *    Resorte: stiffness 26.7, damping 4.1, mass 0.2 (los del ejemplo).
   * ------------------------------------------------------------------ */
  function initDisclosures() {
    $$('[data-disclosure]:not([data-disclosure-ready])').forEach(function (card) {
      card.setAttribute('data-disclosure-ready', '');
      var media = card.querySelector('[data-disclosure-media]');
      var trigger = card.querySelector('[data-disclosure-trigger]');
      var content = card.querySelector('[data-disclosure-content]');
      if (!trigger || !content) return;

      var open = false;
      content.style.overflow = 'hidden';
      content.style.height = '0px';
      content.style.opacity = '0';
      trigger.setAttribute('aria-expanded', 'false');

      function toggle() {
        open = !open;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        card.classList.toggle('is-open', open);

        if (media) {
          anim(media,
            { transform: open ? 'scale(1)' : 'scale(1.1)', filter: open ? 'blur(0px)' : 'blur(3px)' },
            { transform: open ? 'scale(1.1)' : 'scale(1)', filter: open ? 'blur(3px)' : 'blur(0px)' },
            { duration: SPRING_DISCLOSURE.duration, easing: SPRING_DISCLOSURE.easing, willChange: 'transform, filter' });
        }

        content.style.height = 'auto';
        var full = content.scrollHeight;
        content.style.height = open ? '0px' : full + 'px';
        anim(content,
          { height: (open ? 0 : full) + 'px', opacity: open ? 0 : 1 },
          { height: (open ? full : 0) + 'px', opacity: open ? 1 : 0 },
          {
            duration: SPRING_DISCLOSURE.duration,
            easing: SPRING_DISCLOSURE.easing,
            willChange: 'height, opacity',
            onDone: function () {
              content.style.height = open ? 'auto' : '0px';
              content.style.opacity = open ? '1' : '0';
            }
          });
      }

      trigger.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
      /* La imagen tambien abre, como en el ejemplo original. */
      if (media) media.addEventListener('click', toggle);
      window.addEventListener('resize', function () {
        if (open) content.style.height = 'auto';
      });
    });
  }

  /* ---------------------------------------------------------------------
   * 5. Magnetic (port de magnetic.tsx). Solo con puntero fino.
   * ------------------------------------------------------------------ */
  function initMagnetic() {
    if (!finePointer) return;
    $$('[data-magnetic]:not([data-magnetic-ready])').forEach(function (el) {
      el.setAttribute('data-magnetic-ready', '');
      var s = parseFloat(el.getAttribute('data-magnetic') || '0.22');
      el.style.transition = 'transform ' + SPRING_PRESS.duration + 'ms ' + SPRING_PRESS.easing;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' +
          ((e.clientX - (r.left + r.width / 2)) * s).toFixed(1) + 'px,' +
          ((e.clientY - (r.top + r.height / 2)) * s).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = 'translate(0,0)'; });
    });
  }

  /* ---------------------------------------------------------------------
   * 6. Counter — el numero de sucursales
   * ------------------------------------------------------------------ */
  function initCounters() {
    $$('[data-counter]:not([data-counter-ready])').forEach(function (el) {
      el.setAttribute('data-counter-ready', '');
      var to = parseFloat(el.getAttribute('data-counter') || '0');
      var suffix = el.getAttribute('data-counter-suffix') || '';
      onceInView(el, function () {
        var t0 = null, dur = 1100;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(eased * to) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        el.textContent = '0' + suffix;
        requestAnimationFrame(step);
      }, 0.5);
    });
  }

  function init() {
    initReveal();
    initTextEffects();
    initInfiniteSliders();
    initDisclosures();
    initMagnetic();
    initCounters();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  /* El personalizador de Shopify recarga secciones sueltas. */
  doc.addEventListener('shopify:section:load', init);
})();
